<ui-page-header [pageTitle]="'Katalog skupin typu oprávnění k zastupování'">
  <reza-katalog-skupin-sablon-overview-filter></reza-katalog-skupin-sablon-overview-filter>
</ui-page-header>
